import AddProduct from "./add Product/addproduct";
import PurchaseList from "./PurchaseList/PurchaseList";
import GRN from "./GRN/GRN";
import BinManagement from "./Bin Management/BinManagement";

export{AddProduct,PurchaseList,GRN,BinManagement}